import {FC} from "react";
import {Employee} from "@traas/lib/src/api/dto/Employee";
import moment from "moment";

export const EmployeeEmergencyCard: FC<{ employee: Employee }> = (props) => {
  return <div className={'grid grid-cols-5 gap-4 items-center'}>
    <div className={'col-span-2'}>Adres:</div>
    <div className={'col-span-3'}>{props.employee.metadata.emergencySelfAddress ?? '-'}</div>

    <div className={'col-span-2'}>Telefoonnummer:</div>
    <div className={'col-span-3'}>{props.employee.metadata.emergencySelfPhone ?? '-'}</div>

    <div className={'col-span-2'}>Geboortedag:</div>
    <div className={'col-span-3'}>{props.employee.metadata.emergencySelfDateOfBirth ? moment(props.employee.metadata.emergencySelfDateOfBirth).format('DD-MM-YYYY') : '-'}</div>

    <div className={'col-span-2'}>Allergiën:</div>
    <div className={'col-span-3'}>{props.employee.metadata.emergencySelfAllergies ?? '-'}</div>

    <div className={'col-span-2'}>Notities:</div>
    <div className={'col-span-3 bg-slate-100 text-sm rounded-sm px-3 py-2'}>{props.employee.metadata.emergencySelfNote ?? '-'}</div>
  </div>
}